interface ICustomButton {
  type?: "submit" | "button" | "reset";
  title: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  variant?: "primary" | "secondary";
  icon?: React.ReactNode;
}

const CustomButton = ({
  type = "button",
  title,
  onClick,
  className,
  disabled,
  variant,
  icon,
}: ICustomButton) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`group relative inline-flex items-center justify-center gap-2 overflow-hidden px-6 py-3 text-base font-semibold transition-colors duration-300 md:px-10 md:py-4 md:text-lg ${className}`}
    >
      <span
        className={`relative z-10 group-hover:text-legal-dark-blue ${
          variant === "primary" ? "text-legal-white" : "text-legal-dark-blue"
        }`}
      >
        {title}
      </span>
      {icon && (
        <span
          className={`relative z-10 h-4 w-4 group-hover:text-legal-dark-blue md:h-5 md:w-5 ${
            variant === "primary" ? "text-legal-white" : "text-legal-dark-blue"
          }`}
        >
          {icon}
        </span>
      )}

      <span
        className={`absolute inset-0 ${
          variant === "primary" ? "bg-legal-dark-blue" : "bg-legal-brown"
        }`}
      />
      <span
        className={`absolute inset-x-0 bottom-0 h-1 transition-all duration-300 ease-out group-hover:h-full ${
          variant === "primary" ? "bg-legal-brown" : "bg-legal-white"
        }`}
      />
    </button>
  );
};

export default CustomButton;
